import {
    ActivateProductByTrackIdParams,
    ActivateProductParams,
    CloneProductParams,
    DeactivateProductParams,
    DeleteProductParams,
    GetProductsParams,
} from "../types/requestInputs";
import { GetProductsResponse, GetProductsResponseAPI } from "../types/requestsOutputs";
import { AudiotracksCMS, Company } from "../types/types";
import { fetchAPI } from "./utils";

// Get all products for a company
export const getProducts = async ({ token }: GetProductsParams): Promise<GetProductsResponse> => {
    const APIReturn = await fetchAPI<GetProductsResponseAPI>("/get-products-company", "GET", undefined, token);
    return APIReturn.products;
};

export interface GetPaginatedProductsCompanyParams {
    token: string;
    page?: number;
    limit?: number;
    name?: string;
    type?: string;
    countryId?: string;
    cityId?: string;
    companyId?: string;
}

export interface GetPaginatedProductsCompanyResponse {
    products: AudiotracksCMS[];
    companies: Company[];
    pagination: {
        page: number;
        limit: number;
        totalCount: number;
        totalPages: number;
    };
}

/** Paginated + filtered products for Mes expériences only. Leaves getProducts untouched. */
export const getPaginatedProductsCompany = async ({
    token,
    page = 1,
    limit = 20,
    name,
    type,
    countryId,
    cityId,
    companyId,
}: GetPaginatedProductsCompanyParams): Promise<GetPaginatedProductsCompanyResponse> => {
    return fetchAPI<GetPaginatedProductsCompanyResponse>(
        "/get-paginated-products-company",
        "POST",
        {
            page,
            limit,
            name: name || undefined,
            type: type || undefined,
            countryId: countryId || undefined,
            cityId: cityId || undefined,
            companyId: companyId || undefined,
        },
        token,
    );
};

// Activate a product
export const activateProduct = async ({ token, productId }: ActivateProductParams): Promise<String> => {
    return fetchAPI<String>("/activate-product", "POST", { productId }, token);
};

// Deactivate a product
export const deactivateProduct = async ({ token, productId }: DeactivateProductParams): Promise<String> => {
    return fetchAPI<String>("/deactivate-product", "POST", { productId }, token);
};

// Delete a product
export const deleteProduct = async ({ token, productId }: DeleteProductParams): Promise<String> => {
    return fetchAPI<String>("/delete-product", "POST", { productId }, token);
};

// Clone a product
export const cloneProduct = async ({ token, productId }: CloneProductParams): Promise<String> => {
    return fetchAPI<String>("/clone-product", "POST", { productId }, token);
};

// Activate a product by track ID
export const activateProductByTrackId = async ({ token, trackId }: ActivateProductByTrackIdParams): Promise<String> => {
    return fetchAPI<String>("/activate-product-trackid", "POST", { trackId }, token);
};
